import "./styles.less";

import React, { useState } from "react";
import { useOrder } from "./Order.hook";
import { useSearchResultsFilters } from "../../../ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { OrderIcon } from "shared-components/Components/CustomIcons/OrderIcon/web";
import { Button } from "shared-components/Components/Buttons/web";
import { useClickAway } from "shared-components/GlobalHooks/useClickAway";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import { Modal } from "shared-components/Components/Modal/web";


export const Order = ({ textVersion = false }) => {
	const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
	const { filters } = useFilters();
	const screen = useWindowSize()

	const {
		loading,
		data: { options, customKey, valueKey, value, onChange },
		error,
		show,
	} = useOrder({ filterChanged: changeFiltersAndUpdateURL });

	// const GA = useGoogleAnalytics();

	const [open, setOpen] = useState<boolean>(false)
	const dropdownRef = useClickAway(() => { setOpen(false) })

	if (!show) return null;
	if (error) return <div>{"error"}</div>;
	if (loading) return null

	const handleChange = (value) => {
		// GA.Event({
		// 	category: 'user_event',
		// 	action: 'search_change_sort',
		// 	label: value?.text ?? ''
		// })
		onChange(value)
		setOpen(false)
	}

	const getSelectedText = (opt, val) => {
		const res = opt.find(o => o[customKey] == val)
		return res ? res.text : "Popularidad"
	}
	const mapView = filters && filters?.mapView ? filters?.mapView : false;
	const dropDown = (
		<div className="dropdown" >
			{options?.map(opt =>
				<span key={"key_" + opt[customKey]}
					onClick={() => { handleChange(opt) }}
					className={opt[customKey] == value ? 'selected' : ''}
				>
					{opt[valueKey]}
				</span>
			)}
		</div>
	)

	if (textVersion) return (
		mapView ? <></> : <div className="mobile-order">
			<div className="mobile-order__container">
				<span className="mobile-order__container--text">Ordenar por: </span>
				<div
					className="mobile-order__container--selector"
					onClick={() => { setOpen(!open) }}
				>
					<span>{getSelectedText(options, value)}</span>
					<DownArrow color="rgb(53, 57, 78)" />
				</div>
			</div>

			<Modal show={open} onClose={() => { setOpen(false) }} containerStyles={{ minWidth: 250 }} bodyStyles={{ padding: 0 }}>
				<div className="dropdown-popup">
					{dropDown}
				</div>
			</Modal>
		</div>
	)

	return (
		mapView ? <></> : <div className="order-filter" ref={dropdownRef}>
			<Button type="secondary" className="order-filter-btn" onClick={(e: any) => {
				e.preventDefault()
				e.stopPropagation()
				setOpen(!open)
			}} >
				<OrderIcon width={16} />

				<span className="order-filter-btn-text">
					{getSelectedText(options, value)}
				</span>

				{open && dropDown}
			</Button>
		</div>
	);
};
